<script>
import { onMount } from 'svelte'
import { Link } from "svelte-routing";
import Nav from "../widget/Navbar.svelte";
const apiURL = 'https://axcora.my.id/pos-x/API/frontend/about.php';
	let data = [];onMount(async function() {const response = await fetch(apiURL);data = await response.json();});
	
	
</script>
<Nav/>
<div class="container">
<div class="row" >
<div class="col-12 col-md-12 p-3 p-md-5">
{#each data as item}	
<img class="img-fluid rounded shadow" src="{item.cover}" width="100%" alt="{item.description}"/>
<div class="p-3 p-md-5">
<h1 class="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
<span class="block xl:inline"><i class="fas fa-{item.icon}"></i><a href="/"> {item.title}</a></span><br/>
<span class="block text-indigo-600 xl:inline">{item.description}</span>
</h1>
 <p class="text-base text-gray-500 sm:text-lg ">
          {item.content}
          </p>
		 </div>
		  {/each}
		 </div>
</div>
</div>		
       

